module.exports = __webpack_public_path__ + "img/诸暨丹顿.f8c566ea.png";